import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Social' })((theme) => ({
    root: {
        padding: 24,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        borderRadius: 16,
        background: '#F8F8F8',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: 16
        }
    },
    line: {
        display: 'flex',
        alignItems: 'center'
    },
    post: {
        textDecoration: 'none',
        padding: 24,
        borderRadius: 12,
        border: '1px solid #ECECEC',
        background: '#FFF',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        height: '100%',
        width: '100%',
        boxSizing: 'border-box'
    },
    author: {
        margin: '0 0 0 8px',
        color: '#232323',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px'
    },
    text: {
        margin: '0 0 12px 0',
        wordBreak: 'break-word',
        color: '#232323',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%'
    },
    source: {
        marginTop: 'auto',
        marginRight: 'auto',
        background: '#FAFAFA',
        borderRadius: 8,
        boxShadow: 'none',
        textTransform: 'none',
        color: '#979797',
        '&:hover': {
            background: '#efefef',
            boxShadow: 'none'
        }
    }
}));
